import React from 'react';
import { Form } from 'react-bootstrap';

const QuestionField = ({ question, value, onChange, isHighlighted = false }) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleCheckboxChange = (e) => {
    const option = e.target.value;
    const isChecked = e.target.checked;
    
    let newValue = Array.isArray(value) ? [...value] : [];
    
    if (isChecked) {
      if (!newValue.includes(option)) {
        newValue.push(option);
      }
    } else {
      newValue = newValue.filter(v => v !== option);
    }
    
    onChange(newValue);
  };

  const containerClasses = `mb-3 p-3 rounded border ${
    isHighlighted 
      ? 'border-success bg-success bg-opacity-10 shadow-sm' 
      : 'border-light bg-white'
  }`;

  const renderInput = () => {
    switch (question.type) {
      case 'text':
        return (
          <Form.Control
            type="text"
            value={value || ''}
            onChange={handleChange}
            placeholder={`Enter your answer for: ${question.text}`}
            className={isHighlighted ? 'border-success' : ''}
          />
        );
      
      case 'select':
        return (
          <Form.Select
            value={value || ''}
            onChange={handleChange}
            className={isHighlighted ? 'border-success' : ''}
          >
            <option value="">Choose an option...</option>
            {question.options && question.options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </Form.Select>
        );
      
      case 'radio':
        return (
          <div>
            {question.options && question.options.map((option, index) => (
              <Form.Check
                key={index}
                type="radio"
                id={`${question.id}-${index}`}
                name={`question-${question.id}`}
                label={option}
                value={option}
                checked={value === option}
                onChange={handleChange}
                className={isHighlighted ? 'text-success fw-bold' : ''}
              />
            ))}
          </div>
        );
      
      case 'checkbox':
        const selectedValues = Array.isArray(value) ? value : [];
        return (
          <div>
            {question.options && question.options.map((option, index) => (
              <Form.Check
                key={index}
                type="checkbox"
                id={`${question.id}-${index}`}
                label={option}
                value={option}
                checked={selectedValues.includes(option)}
                onChange={handleCheckboxChange}
                className={isHighlighted ? 'text-success fw-bold' : ''}
              />
            ))}
          </div>
        );
      
      default:
        return (
          <Form.Control
            type="text"
            value={value || ''}
            onChange={handleChange}
            placeholder={`Enter your answer for: ${question.text}`}
            className={isHighlighted ? 'border-success' : ''}
          />
        );
    }
  };

  return (
    <div className={containerClasses}>
      <Form.Group>
        <Form.Label className="fw-bold mb-2 d-flex align-items-center">
          <span className="me-2">{question.text}</span>
          {isHighlighted && (
            <span className="badge bg-success small">
              ✨ Just filled
            </span>
          )}
        </Form.Label>
        {renderInput()}
        {question.description && (
          <Form.Text className="text-muted">
            {question.description}
          </Form.Text>
        )}
      </Form.Group>
    </div>
  );
};

export default QuestionField;